import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { ITeam } from "@teammood/team";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatStepperModule } from '@angular/material/stepper';
import { Subject } from "rxjs";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { PollPreviewComponent } from "../../create-poll/poll-preview/poll-preview.component";
import {
    PollPostNowConfirmationDialogData,
    PollTemplate,
    PollUnderCreation,
    QuestionForPreview,
    QuestionTypeKey,
    TeamPollTarget
} from "../../create-poll/create-poll.type";
import { PollType } from "../../polls.type";
import { ScheduleOptionPreview } from "../../create-poll/poll-preview/poll-preview.type";
import { CreatePollService } from "../../create-poll/create-poll.service";
import { PostNowAction } from "../poll-templates.type";


@Component({
    selector: 'poll-post-now-confirmation-dialog',
    templateUrl: 'poll-post-now-confirmation-dialog.component.html',
    styleUrls: ['./../../../timeline/timeline-item/timeline-item.scss', './poll-post-now-confirmation-dialog.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogTitle,
    TranslateModule,
    MatDialogContent,
    ReactiveFormsModule,
    FormsModule,
    MatDialogActions,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    PollPreviewComponent,
]
})
export class PollPostNowConfirmationDialogComponent implements OnInit, OnDestroy {

    protected poll: PollUnderCreation;
    protected pollForPreview: QuestionForPreview;
    protected previewType: PollType;
    protected possibleAnswerOptionTypes: QuestionTypeKey[] = [
        { type: 'AgreeDisagreeQuestion', translateKey: 'poll_creation.type.agree_disagree_question'}, 
        { type: 'ScaleQuestion', translateKey: 'poll_creation.type.scale_question'},
        { type: 'ClosedQuestion', translateKey: 'poll_creation.type.closed_question'},
        { type: 'FiveStarsQuestion', translateKey: 'poll_creation.type.five_stars_question'}
    ]
    protected pollsTemplates: PollTemplate[];
    protected teams: ITeam[];
    protected options: ScheduleOptionPreview;
    protected recipients: number;
    protected authorName: string;

    private _destroy$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) protected dialogInput: PollPostNowConfirmationDialogData,
        private dialogRef: MatDialogRef<PollPostNowConfirmationDialogComponent>,
        private translate: TranslateService,
        private createPollService: CreatePollService
    ) {}

    ngOnInit() {
        this.teams = this.dialogInput.teams;
        this.pollsTemplates = this.dialogInput.pollTemplates;
        this.authorName = this.dialogInput.author;
        this.poll = PollUnderCreation.fromEmpty();
        this.setParametersForFromTemplatePollCreation(this.dialogInput.pollTemplates[0]);
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async setParametersForFromTemplatePollCreation(template: PollTemplate){
        this.poll = PollUnderCreation.fromTemplate(template);
        const teamIds = this.teams.map(team => team.id);
        this.poll.target = { teamIds: teamIds } as TeamPollTarget; 
        this.recipients = await this.createPollService.getPollRecipients(teamIds);
        this.options = await this.createPollService.getScheduleOptions(this.poll.scheduleOptions);
        this.previewType = this.poll.answerOptions.type;
        this.pollForPreview = {
            label: this.poll.label,
            choices: PollUnderCreation.fromChoiceListToTypedAnswerOption(this.poll.answerOptions, this.translate)
        }
    }

    protected action(action: PostNowAction){ 
        this.dialogRef.close(action);
    }
}
